// Full FAQ (used on /faq page and for FAQPage JSON-LD).
export const FAQS_FULL = [
  {
    id: "csection",
    q: "Is your care safe after a C-section?",
    a: "Yes. Many of our mothers come after a C-section. Dr. Nimisha checks your wound and recovery on arrival, and the treatments are adjusted until it has healed well. Abdomen work and some therapies start only when the doctor says it is safe.",
  },
  {
    id: "when-after-delivery",
    q: "When can I come after delivery?",
    a: "Most mothers arrive within the first 1 to 2 weeks after a normal delivery, or once they are discharged and comfortable after a C-section. Tell us your due date and we plan around it.",
  },
  {
    id: "how-long",
    q: "How long should I stay?",
    a: "The classical Sutika Kala is 42 days, and that gives the deepest recovery. We also offer 7, 14, 21 and 28 day stays. The 21 day Full Sequence is the most chosen.",
  },
  {
    id: "cost",
    q: "What does it cost?",
    a: "Packages start at ₹15,000 for 7 days in a non-AC villa, up to ₹88,500 for the full 42 days. Stay, meals, treatments, doctor visits and a bystander are all included.",
  },
  {
    id: "bystander",
    q: "Can my husband or mother stay with me?",
    a: "Yes. One bystander stays with you in the villa, and their meals are included.",
  },
  {
    id: "baby-care",
    q: "Do you care for the baby too?",
    a: "Yes. Our caregivers help with baby oil massage and bathing in the traditional way, and guide you so you can continue at home.",
  },
  {
    id: "food",
    q: "What will I eat?",
    a: "Seven fresh meals a day from our kitchen: warm milk, Kerala breakfasts like puttu, appam and idiyappam, a full Kerala lunch, evening snacks and a light dinner. Food is made for recovery and good milk supply.",
  },
  {
    id: "treatments",
    q: "Which treatments will I get?",
    a: "Your plan is made after the doctor sees you. It can include Abhyangam, Vethu Kuli, steam bath, Kizhi, Pichu, Udhwarthanam, Dhara, abdomen bandaging and Dhoopanam.",
  },
  {
    id: "doctor",
    q: "Who is the doctor?",
    a: "Dr. Nimisha is our treating physician and visits you every 2 days. The centre was founded by Dr. Krishnakumar KV (BAMS, MD Ayurveda), from a family that has made Ayurvedic medicines since 1946.",
  },
  {
    id: "nri",
    q: "I live in the Gulf. Can I still book?",
    a: "Yes. Many NRI mothers book on WhatsApp before flying home. Kochi and Calicut airports are both about 2.5 hours away by road.",
  },
  {
    id: "when-to-book",
    q: "When should I book?",
    a: "As early as you can. We have only 3 villas, and they are often booked months ahead. An advance of ₹5,000 holds your villa.",
  },
  {
    id: "contact",
    q: "How do I contact you?",
    a: "WhatsApp +91 90616 22255, 9am to 8pm. Or visit us at Paruthipra, Shoranur, Palakkad 679121.",
  },
];
